import React, { Component, PropTypes } from 'react'
import styles from './Review.css'
import ReviewInfo from './ReviewInfo'
import ResetConfirmModal from './ResetConfirmModal'

class ResetReview extends Component {
  constructor (props) {
    super(props)
    this.state = ({
      showConfirmModal: false
    })
  }

  render () {
    return (
      <div className={styles['splash-page']}>
        <div style={{padding: '0px 30px 30px 30px'}}>
          <ReviewInfo {...this.props} />
          <div className='row'>
            <div className={`col-md-12 text-center ${styles['button-fixed-position']}`}>
              <button
                onClick={this._onClickRevise}
                className={`btn btn-default btn-lg ${styles['review-button-revise']}`}
              >
                Revise
              </button>
              <button
                onClick={this._onClickConfirm}
                className={`btn btn-primary btn-lg ${styles['review-button-confirm']}`}
              >
                Confirm Program
              </button>
            </div>
          </div>
        </div>
        <ResetConfirmModal
          confirmReset={this._confirmReset}
          close={this._closeConfirmModal}
          show={this.state.showConfirmModal}
        />
      </div>
    )
  }

  _confirmReset = () => {
    this.setState({
      showConfirmModal: false
    })

    this.props.confirmProgram()
  }

  _onClickConfirm = (e) => {
    e.stopPropagation()
    this.setState({
      showConfirmModal: true
    })
  }

  _closeConfirmModal = (e) => {
    this.setState({
      showConfirmModal: false
    })
  }

  _onClickRevise = (e) => {
    e.stopPropagation()
    this.props.revise()
  }

}

ResetReview.propTypes = {
  pointFromSpendingAmount: PropTypes.array.isRequired,
  rewards: PropTypes.array.isRequired,
  spendingAmount: PropTypes.number.isRequired,
  newMemberPoint: PropTypes.number.isRequired,
  revise: PropTypes.func.isRequired
}

export default ResetReview



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/Review/ResetReview.js